import { BaseForRestoreVMPlanHelper } from 'wizards/helpers/bases/base-for-restore-vm-plan-helper';

export class RestoreHyperVPlanFromStepsHelpers extends BaseForRestoreVMPlanHelper {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected static setSpecificStepsData(newPlan: any): void {
    // Here specific data
  }
}
